import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getProjectById } from "$/modules/projects/lib/projects";
import { QuizPlayerProvider } from "$/modules/shared/provider/quiz-player-provider";

export const Route = createFileRoute("/$locale/quiz-player/$projectId")({
	component: QuizPermissionLayout,
	loader: async ({ params }) => {
		const project = await getProjectById({
			projectId: params.projectId,
		});

		return {
			project,
		};
	},
});

function QuizPermissionLayout() {
	const { locale } = Route.useParams();
	const { project } = Route.useLoaderData();

	if (!project) throw redirect({ to: "/", params: { locale } });
	if (!project) return null;

	return (
		<QuizPlayerProvider project={project}>
			<Outlet />
		</QuizPlayerProvider>
	);
}
